import * as yup from 'yup';
import { pastOrTodayDateSchema, requiredErrorMessage } from '@common/schema';
import {
  MAXIMUM_STRING_LENGTH,
  MAXIMUM_TEXT_AREA_LENGTH,
  TASK_MAX_RECORDED_MINUTES,
} from '@common/types/constants.ts';

export const addActivityLogSchema = yup.object().shape({
  title: yup
    .string()
    .max(
      MAXIMUM_STRING_LENGTH,
      `This input must be ${MAXIMUM_STRING_LENGTH} characters or less. Please reduce the length to proceed.`,
    )
    .required(requiredErrorMessage),
  timestamp: pastOrTodayDateSchema.required(requiredErrorMessage),
  description: yup
    .string()
    .max(
      MAXIMUM_TEXT_AREA_LENGTH,
      `This input must be ${MAXIMUM_TEXT_AREA_LENGTH} characters or less. Please reduce the length to proceed.`,
    )
    .optional(),
  recorded_minutes: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? undefined : value,
    )
    .integer('Minutes must be a whole integer')
    .max(
      TASK_MAX_RECORDED_MINUTES,
      `Minutes must be smaller or equal to ${TASK_MAX_RECORDED_MINUTES}`,
    )
    .min(0, 'Minutes must be greater or equal to 0')
    .required(requiredErrorMessage),
  provider_id: yup.string().optional(),
  practice_id: yup.string().optional(),
  building_id: yup.string().optional(),
});
